import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const useApplyOfferCodeApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({order, code}: Params.ApplyDiscountCode) => {
      const {data} = await ventrata.patch<Ventrata.Booking>(
        `/bookings/${order.bookings[0].uuid}`,
        {offerCode: code},
        {headers: {'Octo-Capabilities': 'octo/offers'}}
      )

      return data
    },
    [ventrata]
  )
}
